// Module
var code = "<a></a> ";
// Exports
export default code;